package kz.dentalcrm.app.core.ui.components

import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import compose.icons.FeatherIcons
import compose.icons.feathericons.X
import kz.dentalcrm.app.theme.DefaultTheme

@Composable
fun UIIconBackButton(
    enabled: Boolean = true,
    iconTint: Color = DefaultTheme.colors.onSurface,
    onClick: () -> Unit
) {
    IconButton(
        modifier = Modifier.size(
            32.dp
        ),
        enabled = enabled,
        content = {
            Icon(
                imageVector = FeatherIcons.X,
                contentDescription = null,
                tint = iconTint,
                modifier = Modifier.size(24.dp)
            )
        },
        shape = RoundedCornerShape(32.dp),
        onClick = onClick
    )
}